import { render, staticRenderFns } from "./ResourceLanguage.vue?vue&type=template&id=fa2cb7fc&scoped=true&"
import script from "./ResourceLanguage.vue?vue&type=script&lang=js&"
export * from "./ResourceLanguage.vue?vue&type=script&lang=js&"
import style0 from "./ResourceLanguage.vue?vue&type=style&index=0&id=fa2cb7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2cb7fc",
  null
  
)

export default component.exports